import {
  DefaultButton,
  FontWeights,
  getTheme,
  IButtonStyles,
  ILabelStyles,
  Label,
  mergeStyleSets,
  Modal,
  Stack,
  IconButton,
  IIconProps
} from "@fluentui/react";
import * as React from "react";

import styled from "styled-components";

const theme = getTheme();
const RenameBtn = styled.button`
  border: 0px;
  width: 100%;
  height: 50%;
  padding: 0px;
`;
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    borderRadius: "2em",
    minWidth: "500px !important",
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: "1 1 auto",
      color: "#CC214F",
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    textAlign: "center",
    flex: "4 4 auto",
    padding: "0 24px 12px 24px",
    overflowY: "hidden",
    selectors: {
      p: {
        margin: "0",
      },
      "p:first-child": {
        marginTop: 0,
      },
      "p:last-child": {
        marginBottom: 0,
      },
    },
  },
});
const styleLabel: Partial<ILabelStyles> = {
  root: {
    fontSize: "19px !important",
    padding: "0 45px",
    margin: "0px",
    textAlign: "center",
    width: "100%",
  },
};
const styleDefButton1: Partial<IButtonStyles> = {
  root: {
    marginLeft: "0",
    marginTop: "1em",
    cursor: "pointer",
    background: "#CC214F",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "center",
    color: "#FFFFFF",
    borderRadius: "100px",
    padding: "0.5em 1.5em 0.5em 1.5em",
    borderStyle: "none",
  },
};
const styleDefButton2: Partial<IButtonStyles> = {
  root: {
    marginLeft: "2em",
    marginTop: "1em",
    cursor: "pointer",
    background: "#CC214F",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "center",
    color: "#FFFFFF",
    borderRadius: "100px",
    padding: "0.5em 1.5em 0.5em 2em",
    borderStyle: "none",
  },
};

type Props = {
  title?: string;
  body?: string | JSX.Element | JSX.Element[];
  btnSubmitText?: string;
  btnSubmitDisabled?: boolean;
  onSubmit?: any;
  onClose?: any;
  size?: "sm" | "lg" | "xl";
  showModal: boolean;
  setShowModal: (b: boolean) => any;
};

export const ModalWithCancel: React.FunctionComponent<Props> = (
  props: Props
) => {
  const { body, title, btnSubmitText, showModal, btnSubmitDisabled, size, setShowModal } =
    props;
  const [show, setShow] = React.useState(false);
  const cancelIcon: IIconProps = { iconName: 'Cancel' };

  const handleClose = () => {
    setShowModal(false);
    if (props.onClose !== undefined) {
      props.onClose();
    }
  };

  React.useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  const onSubmit = async () => {
    if (props.onSubmit !== undefined) {
      props.onSubmit();
    }
    handleClose();
  };


  


  return (
    <React.Fragment>
      <Modal isOpen={show} onDismiss={handleClose}>
      <div className={contentStyles.header}>
                    <Label styles={styleLabel}>{title}</Label>                   
                    <IconButton iconProps={cancelIcon} ariaLabel="Cerrar modal" onClick={handleClose}/>
                </div>
        <div className={contentStyles.body}>
        <p className="text-center">{body}</p>
        </div>
        <Stack.Item
          style={{ display: "flex", justifyContent: "center", padding: "10px" }}
        >
          <DefaultButton styles={styleDefButton2} onClick={onSubmit}>
            Aceptar
          </DefaultButton>
        </Stack.Item>
      </Modal>
    </React.Fragment>
  );
};
